export const getHeaderOffset = (fallback = 0) => {
  if (typeof window === "undefined") return fallback;
  const header = document.querySelector("header");
  let offset = header ? header.getBoundingClientRect().height : 0;
  if (!offset) {
    const val = getComputedStyle(document.documentElement).getPropertyValue("--navbar-height");
    const parsed = parseFloat(val || "0");
    if (Number.isFinite(parsed)) offset = parsed;
  }
  return offset || fallback;
};

export const scrollHeaderIntoView = (el, behavior = "auto", extra = 8) => {
  if (!el || typeof window === "undefined") return;
  const offset = getHeaderOffset(0) + extra;
  const rect = el.getBoundingClientRect();
  const top = window.scrollY + rect.top - offset;
  window.scrollTo({ top, behavior });
};
